import ReCAPTCHA from 'react-google-recaptcha';
import { ReCaptchaState } from './ReCaptchaState';
import {
  RecaptchaSiteVerifyApiService,
  RecaptchaSiteVerifyRequest,
} from '../../api/services';
import { Session } from '../../api/framework/session';

export const validateReCaptcha = async (
  reCaptchaRef: React.RefObject<ReCAPTCHA>
): Promise<ReCaptchaState> => {
  const token = reCaptchaRef.current?.getValue();

  if (
    reCaptchaRef.current === null ||
    token === undefined ||
    token === null ||
    token.length === 0
  ) {
    return ReCaptchaState.Error_Unchecked;
  } else {
    const reCaptchIsValid = await makeReCaptchaValidationCall(token);
    reCaptchaRef.current.reset();
    if (!reCaptchIsValid) {
      return ReCaptchaState.Error_Failed;
    }
  }

  return ReCaptchaState.OK;
};

const makeReCaptchaValidationCall = async (token: string): Promise<boolean> => {
  // call to verify reCaptcha
  const request: RecaptchaSiteVerifyRequest = {
    captchaToken: token,
  };

  const response = await RecaptchaSiteVerifyApiService.execute(request);
  const success = response.succeeded && response.data?.success === true;
  if (success) {
    Session.Instance.token = response.data?.authenticationToken;
  }

  return success;
};
